
import React from "react";
import { UserInvitation } from "@/types/userInvitation";
import { TokenStatus } from "@/hooks/useInvitationToken";

export enum WelcomeState {
  LOADING,
  INVALID_TOKEN,
  EXPIRED_TOKEN,
  ALREADY_ACCEPTED,
  VALID_TOKEN,
  CREATING_ACCOUNT,
  ACCOUNT_CREATED,
  EDITING_LOCATION
}

interface WelcomeDebugInfoProps {
  welcomeState: WelcomeState;
  tokenValue: string | null;
  tokenStatus: TokenStatus;
  hasUpdatedViewedTime: boolean;
  invitation: UserInvitation | null;
}

export const WelcomeDebugInfo: React.FC<WelcomeDebugInfoProps> = ({
  welcomeState,
  tokenValue,
  tokenStatus,
  hasUpdatedViewedTime,
  invitation
}) => {
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }
  
  // Helper function to safely extract organization ID string
  const getOrganizationId = (invitation: UserInvitation | null) => {
    if (!invitation || !invitation.organization) return "None";
    return invitation.organization.id || "Unknown";
  };
  
  return (
    <div className="mt-8 p-4 border border-dashed border-gray-300 rounded w-full max-w-md">
      <details open>
        <summary className="cursor-pointer font-medium">Debug Information</summary>
        <div className="mt-2 text-sm space-y-1 text-left">
          <p><strong>State:</strong> {WelcomeState[welcomeState]} ({welcomeState})</p>
          <p><strong>Token:</strong> {tokenValue || 'None'}</p>
          <p><strong>Updated Viewed Time:</strong> {hasUpdatedViewedTime ? 'Yes' : 'No'}</p>
          <p><strong>Token Status:</strong> {TokenStatus[tokenStatus]} ({tokenStatus})</p>
          {invitation && (
            <>
              <p><strong>Invitation ID:</strong> {invitation.id}</p>
              <p><strong>Invitation Status:</strong> {invitation.status}</p>
              <p><strong>Invitation Type:</strong> {invitation.type || 'user_invite (default)'}</p>
              <p><strong>Will Expire At:</strong> {invitation.willExpireAt?.toDate().toLocaleString()}</p>
              <p><strong>Organization ID:</strong> {getOrganizationId(invitation)}</p>
              {invitation.resultingUser && (
                <p><strong>Resulting User ID:</strong> {invitation.resultingUser.id}</p>
              )}
            </>
          )}
        </div>
      </details>
    </div>
  );
};
